module.exports = __webpack_public_path__ + "static/media/ujjal.5bbf14e3.jpg";